// Shared error formatter for createAsyncThunk's rejectWithValue path.
// Builds a readable message from the API response. If the backend returned
// per-field validation errors (express-validator), formats them as
// "field: message · field2: message2" so the user sees what's wrong.
// Falls back to the generic message ("Validation failed") only when no
// field errors are present.
const errMsg = (err, fallback) => {
  const data = err?.response?.data;
  const fieldErrors = Array.isArray(data?.errors) ? data.errors : [];

  if (fieldErrors.length) {
    const lines = fieldErrors
      .map((e) => {
        const field = e.field || e.path || e.param;
        const msg = e.message || e.msg;
        if (field && msg) return `${field}: ${msg}`;
        return msg || field;
      })
      .filter(Boolean);
    if (lines.length) return lines.join(" · ");
  }

  return data?.message || err?.message || fallback;
};

export default errMsg;
